<app-header [showAvatar]="false" title="SMTP Settings" [useTabs]="false">
</app-header>
<div class="body">
  <div class="body-container">
    <div class="page-main">
      <div class="page-container">

        <form *ngIf="isFormReady" [formGroup]="form" novalidate class="form-wrapper">
          <div class="form-content">
            <div class="form-section">
              <div class="form-section-side">
                <h1 class="label-title">SMTP Server Settings</h1>
                <p class="label-subtitle">If you're using a third party service provider, the number of emails that can be sent from Rebillia depends on their email limit.</p>
                <p class="label-note">All custom dunning templates you have created are translated based off the default dunning template. You will have to manually translate them to your own custom copy. Learn more</p>
              </div>
              <div class="form-section-container">
                <div class="form-section-body">
                  <div class="form-row">
                    <mat-form-field floatLabel="always" class="custom-mat-form-field size size1of1">
                      <mat-label>SMTP Server Address</mat-label>
                      <input matInput placeholder="e.g. smtp.gmail.com" formControlName="smtpServerAddress">
                    </mat-form-field>
                  </div>
                  <div class="form-row">
                    <mat-form-field floatLabel="always" class="custom-mat-form-field size size1of1">
                      <mat-label>User name</mat-label>
                      <input matInput placeholder="e.g. johnsmith@example.com" formControlName="smtpUserName">
                    </mat-form-field>
                  </div>
                  <div class="form-row">
                    <mat-form-field floatLabel="always" class="custom-mat-form-field size size1of1">
                      <mat-label>Password</mat-label>
                      <input matInput placeholder="Type your password here" [type]="hidePassword ? 'password' : 'text'" formControlName="smtpPassword">
                      <mat-icon matSuffix (click)="hidePassword = !hidePassword">{{ hidePassword ? 'visibility' : 'visibility_off' }}</mat-icon>
                    </mat-form-field>
                  </div>
                  <div class="form-row">
                    <mat-form-field floatLabel="always" class="custom-mat-form-field size size1of2">
                      <mat-label>Port Number</mat-label>
                      <input matInput #portNumber placeholder="e.g 465, 587" formControlName="smtpPortNumber">
                    </mat-form-field>
                    <mat-form-field class="custom-mat-form-field size size1of2">
                      <mat-label>Encryption Type</mat-label>
                      <mat-select (change)="encriptionType($event)" formControlName="smtpEncryptionType">
                        <mat-option value="ssl">SSL</mat-option>
                        <mat-option value="tls">TLS</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <nav class="post-form">
            <button mat-flat-button (click)="onSubmit()" color="primary" class="custom-mat-button-primary rounded typo uppercase size size1of1">Save Changes</button>
          </nav>
        </form>

        <!-- skeleton form-sections -->
        <div *ngIf="!isFormReady">
          <skeleton-loader-form [top]=true [numberOfInputs]=4></skeleton-loader-form>
        </div>

      </div>
    </div>
  </div>
</div>
